// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Map from "rescript/lib/es6/belt_Map.js";
import * as Belt_Set from "rescript/lib/es6/belt_Set.js";
import * as Db$Coronate from "../Db.res.js";
import * as PervasivesU from "rescript/lib/es6/pervasivesU.js";
import * as Core__Promise from "@rescript/core/src/Core__Promise.res.js";
import * as Hooks$Coronate from "../Hooks.res.js";
import * as Window$Coronate from "../Window.res.js";
import * as Data_Id$Coronate from "../Data/Data_Id.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Data_Player$Coronate from "../Data/Data_Player.res.js";
import * as Data_Rounds$Coronate from "../Data/Data_Rounds.res.js";
import * as Data_Tournament$Coronate from "../Data/Data_Tournament.res.js";
import * as LocalForage_Map$Coronate from "../Externals/LocalForage_Map.res.js";

function log2(num) {
  return Math.log(num) / Math.log(2.0);
}

function calcNumOfRounds(playerCount) {
  var roundCount = Math.ceil(log2(playerCount));
  if (roundCount !== PervasivesU.neg_infinity) {
    return roundCount | 0;
  } else {
    return 0;
  }
}

var emptyTourney = Data_Tournament$Coronate.make(Data_Id$Coronate.random(), "");

function tournamentReducer(param, action) {
  return action;
}

function isLoadedDone(x) {
  switch (x) {
    case "NotLoaded" :
        return false;
    case "Loaded" :
    case "Error" :
        return true;
    
  }
}

function LoadTournament(props) {
  var windowDispatch = props.windowDispatch;
  var tourneyId = Data_Id$Coronate.toString(props.tourneyId);
  var match = React.useReducer(tournamentReducer, emptyTourney);
  var tourney = match[0];
  var roundList = tourney.roundList;
  var playerIds = tourney.playerIds;
  var name = tourney.name;
  var setTourney = match[1];
  var match$1 = Db$Coronate.useAllPlayers();
  var arePlayersLoaded = match$1.loaded;
  var players = match$1.items;
  var match$2 = React.useState(function () {
        return "NotLoaded";
      });
  var setTourneyLoaded = match$2[1];
  var tourneyLoaded = match$2[0];
  Hooks$Coronate.useLoadingCursorUntil(isLoadedDone(tourneyLoaded) && arePlayersLoaded);
  var actualWindowDispatch = windowDispatch !== undefined ? windowDispatch : (function (param) {
        
      });
  React.useEffect((function () {
          actualWindowDispatch({
                TAG: "SetTitle",
                _0: name
              });
          return (function () {
                    actualWindowDispatch({
                          TAG: "SetTitle",
                          _0: ""
                        });
                  });
        }), [
        name,
        actualWindowDispatch
      ]);
  React.useEffect((function () {
          var didCancel = {
            contents: false
          };
          Core__Promise.$$catch(LocalForage_Map$Coronate.getItem(Db$Coronate.tournaments, tourneyId).then(function (value) {
                    if (didCancel.contents) {
                      return ;
                    } else if (value !== undefined) {
                      setTourney(value);
                      return setTourneyLoaded(function (param) {
                                  return "Loaded";
                                });
                    } else {
                      return setTourneyLoaded(function (param) {
                                  return "Error";
                                });
                    }
                  }), (function (param) {
                  if (!didCancel.contents) {
                    setTourneyLoaded(function (param) {
                          return "Error";
                        });
                  }
                  return Promise.resolve();
                }));
          return (function () {
                    didCancel.contents = true;
                  });
        }), [tourneyId]);
  React.useEffect((function () {
          switch (tourneyLoaded) {
            case "Loaded" :
                if (Data_Id$Coronate.eq(Data_Id$Coronate.fromString(tourneyId), tourney.id)) {
                  LocalForage_Map$Coronate.setItem(Db$Coronate.tournaments, tourneyId, tourney);
                }
                break;
            case "NotLoaded" :
            case "Error" :
                break;
            
          }
        }), [
        tourneyLoaded,
        tourneyId,
        tourney
      ]);
  switch (tourneyLoaded) {
    case "NotLoaded" :
        break;
    case "Loaded" :
        if (arePlayersLoaded) {
          var activePlayers = Belt_Map.keep(players, (function (id, param) {
                  return Belt_Set.has(playerIds, id);
                }));
          var roundCount = calcNumOfRounds(Belt_Map.size(activePlayers));
          var isItOver = Data_Rounds$Coronate.size(roundList) >= roundCount;
          var isNewRoundReady = Data_Rounds$Coronate.size(roundList) === 0 ? true : Data_Rounds$Coronate.isRoundComplete(roundList, activePlayers, Data_Rounds$Coronate.size(roundList) - 1 | 0);
          return props.children({
                      activePlayers: activePlayers,
                      getPlayer: (function (extra) {
                          return Data_Player$Coronate.getMaybe(players, extra);
                        }),
                      isItOver: isItOver,
                      isNewRoundReady: isNewRoundReady,
                      players: players,
                      playersDispatch: match$1.dispatch,
                      roundCount: roundCount,
                      tourney: tourney,
                      setTourney: setTourney
                    });
        }
        break;
    case "Error" :
        return JsxRuntime.jsx(Window$Coronate.Body.make, {
                    children: "Error: tournament couldn't be loaded.",
                    windowDispatch: actualWindowDispatch
                  });
    
  }
  return JsxRuntime.jsx(Window$Coronate.Body.make, {
              children: "Loading...",
              windowDispatch: actualWindowDispatch
            });
}

var make = LoadTournament;

export {
  make ,
}
/* emptyTourney Not a pure module */
